/**
 * Interface for member policies.
 */
export interface IMemberPolicy {
    /**
     * Gets or sets the name of the definition that contains the target.
     */
    definitionName: string;

    /**
     * Gets or sets the member on the definition where the canRead and canWrite properties apply on.
     */
    target: string;

    /**
     * Gets or sets whether the user(group) that has this policy can read the target.
     */
    canRead: boolean;

    /**
     * Gets or sets whether the user(group) that has this policy can write to the target.
     */
    canWrite: boolean;
}

/**
 * A member policy.
 */
export class MemberPolicy implements IMemberPolicy {
    definitionName: string;

    target: string;

    canRead: boolean;

    canWrite: boolean;

    constructor(init?: Partial<MemberPolicy>) {
        Object.assign(this, init);
    }
}
